const listPointsBody = document.querySelector('#cntUsers').querySelector('div[name="body"]');
// import auth from '../tools/storage.js';

import tools from '../tools/tools.js';

export default {

  cleanContainer() {
    listPointsBody.innerHTML = '';
  },

  formatedPhone (strPhone) {
    strPhone = strPhone.toString()
    if(strPhone.length == 11)
      if(parseInt(strPhone.substr(0,1), 10) === 7)
        return `+7 (${strPhone.substr(1,3)}) ${strPhone.substr(4,2)} ${strPhone.substr(6,2)} ${strPhone.substr(8,3)}`;
      
    return strPhone;
  },


  getElement(item, index) {

    let lbStatus = 'актвен';
    let lbStatusClass = 'Active';

    if (parseInt(item.status, 10) === 0)
    {
      lbStatusClass = 'NotActive';
      lbStatus = 'отключен';
    }
    
    return `
    <label class="reference-header"  userID="${item.uid}">
        <div class="txt-al-center w-3 "  userID="${item.uid}">${index + 1}</div>
        <div class=" ml-3 mr-auto"  userID="${item.uid}"><b  userID="${item.uid}">${item.name}</b></div>

        <div class="w-15  mr-1 " userID="${item.uid}" >${tools.formatedPhone(item.phone)}</div>
        <div class="w-25 mr-1 " userID="${item.uid}" >${tools.dateStringFull(item.lastActive)}</div>
        <div class="w-5  mr-3"  userID="${item.uid}"><small class="userLbl${lbStatusClass}">${lbStatus}</small></div>


    </label>`;


  },

  drawDataInContainer(enterprisesData) {
    let htmlBody = `
    <div class="reference-header">
        <div class="txt-al-center w-3">№</div>
        <div class=" ml-3 mr-auto">ФИО</div>
        <div class="w-15  mr-1">Телефон</div>
        <div class="w-25 mr-1">Время последнего сеанса (UTC)</div>
        <div class="w-5  mr-3">Статус</div>
       
    </div>  `;
    
    if(enterprisesData)
      enterprisesData.forEach((item, index) => htmlBody += this.getElement(item, index));

    listPointsBody.innerHTML = htmlBody;
  },

  drawMarkupInContainer(markup) {
    listPointsBody.insertAdjacentHTML('beforeend', markup);
  },

};
